module.exports = __webpack_public_path__ + "img/握手.f23d751f.gif";